class Player {
  constructor(phxComponent) {
    this._phxComponent = phxComponent;
    this._container = phxComponent.el;
    this._updateVideoSize = this._updateVideoSize.bind(this);
    this._switchPlayer = this._switchPlayer.bind(this);
    this._playerStartPlaying = this._playerStartPlaying.bind(this)
    this._startHLSPlayer = this._startHLSPlayer.bind(this)
    this._startWebRTCPlayer = this._startWebRTCPlayer.bind(this)
    this._toggleMute = this._toggleMute.bind(this)
    this._toggleFullscreen = this._toggleFullscreen.bind(this)
    this._togglePictureInPicture = this._togglePictureInPicture.bind(this)
    this._setStateToUnMuted = this._setStateToUnMuted.bind(this)
    this._restartWebRTCPlayer = this._restartWebRTCPlayer.bind(this)
    this._displayPlayButton = this._displayPlayButton.bind(this)
    this._isMuted = false;
    this._createControlOverlay();
    this._initAndPlay();
    this._fallbackTried = false
  }

  _initAndPlay(){
    this._phxComponent.pushEvent("player_mounted", {}, (rep, ref) => {
      this._webRTCStreamUrl = rep.webrtc_stream_url
      this._hlsStreamUrl = rep.hls_stream_url
      this._startWebRTCPlayer();
      //this._startHLSPlayer();
      this._displayLoading()
    })
  }

  _startWebRTCPlayer(){
    import(/* webpackPrefetch: true */ './webrtc_player.js').then(({WebRTCPlayer}) => {
      this._player = new WebRTCPlayer(this._phxComponent.el, this._webRTCStreamUrl);
      this._player.onVideoResizeCB = this._updateVideoSize
      this._player.onStartPlayingCB = this._playerStartPlaying
      this._player.onIsStreamStartMuted = this._setStateToUnMuted
      this._player.onStreamFailedCB = this._restartWebRTCPlayer
      this._player.onDisplayPlayButton = this._displayPlayButton
      //this._observeForFailures()
    })
  }

  _startHLSPlayer() {
    import(/* webpackPrefetch: true */ './hls_player.js').then(({HLSPlayer}) => {
      this._player = new HLSPlayer(this._phxComponent.el, this._hlsStreamUrl);
      this._player.onVideoResizeCB = this._updateVideoSize
      this._player.onStartPlayingCB = this._playerStartPlaying
      //this._observeForFailures()
    })
  }

  _observeForFailures() {
    setTimeout(() => {
      if (this._playerStarted !== true && this._fallbackTried === false) {
        this._lowLatencyCheckbox.checked = !this._lowLatencyCheckbox.checked
        this._switchPlayer()
        this._fallbackTried = true
      }
    }, 5000)
  }

  _restartWebRTCPlayer() {
    console.log("restarting webrtc player...")
    this._player.destroy();
    //setTimeout(this._startWebRTCPlayer, 200);
    this._phxComponent.pushEvent("is_stream_live?", {}, ({is_live}) => {
      if (is_live) {
        setTimeout(this._startWebRTCPlayer, 200);
      }
    })
  }

  _updateVideoSize({width, height}){
    let videoEl = this._container.querySelector('video')
    console.log("_updateVideoSize to: ", width, height)
    videoEl.style.width = "100%"
    if (height > width ) {
      videoEl.style.height = "100%"
    } else {
      if (this._container && this._container.parentNode) {
        this._container.parentNode.style.paddingBottom = `${100/(width/height)}%`
      }
    }
  }

  _switchPlayer(){
    console.log("Player Change", this._lowLatencyCheckbox.checked)
    console.log(this)
    if (this._lowLatencyCheckbox.checked) {
      this._player.destroy()
      this._startWebRTCPlayer();
    } else {
      this._player.destroy()
      this._startHLSPlayer();
    }
  }

  _createControlOverlay(){
    let overlay = document.createElement('div')
    overlay.className = "absolute inset-0 group-hover:opacity-100 z-10 transition-all bg-gradient-to-b from-black to-transparent"
    overlay.style.height="30%"

    let controlsContainer = document.createElement('div')
    controlsContainer.className = "absolute right-4 top-4 flex flex-end items-center"

    let checkbox = document.createElement('input')
    checkbox.type = "checkbox"
    checkbox.checked = true
    checkbox.addEventListener('change', this._switchPlayer)

    let label = document.createElement('label')
    label.className = "mr-2 text-white"
    label.innerText = "Ultra-low latency"

    controlsContainer.appendChild(label)
    controlsContainer.appendChild(checkbox)
    overlay.appendChild(controlsContainer)
    this._lowLatencyCheckbox = checkbox;
    this._overlay = overlay;
    this._controlsContainer = controlsContainer;
    this._createMuteButton();
    this._createFullscreenButton();
    this._createPictureInPictureButton();
    this._container.appendChild(overlay);
    setTimeout(() => { this._overlay.classList.add("opacity-0")}, 5000)
  }

  _createMuteButton(){
    let button = document.createElement("div")

    button.className = "p-1 m-1 ml-4 cursor-pointer rounded bg-black bg-opacity-40"
    button.addEventListener('click', this._toggleMute )
    this._muteButton = button
    this._controlsContainer.appendChild(button)
  }

  _createFullscreenButton(){
    let button = document.createElement("div")

    button.className = "p-1 m-1 ml-4 cursor-pointer rounded bg-black bg-opacity-40"
    button.innerHTML = "<i class='fas fa-lg fa-expand text-white'></i>"
    button.addEventListener('click', this._toggleFullscreen )
    this._fullscreenButton = button
    this._controlsContainer.appendChild(button)
  }

  _createPictureInPictureButton(){
    if (this._container.dataset["allowPip"] && document.pictureInPictureEnabled) {
      let button = document.createElement("div")

      button.className = "p-1 m-1 ml-4 cursor-pointer rounded bg-black bg-opacity-40 hidden md:block"
      button.innerHTML = "<i class='fas fa-lg fa-arrow-up-from-bracket text-white'></i>"
      button.addEventListener('click', this._togglePictureInPicture )
      this._pictureInPictureButton = button
      this._controlsContainer.appendChild(button)
    }
  }

  _toggleMute(){
    if (this._isMuted) {
      this._muteButton.innerHTML = "<i class='fas fa-lg fa-volume-up text-white'></i>"
      this._player.unmute()
      this._removeMuteStatus()
    } else {
      this._muteButton.innerHTML = "<i class='fas fa-lg fa-volume-mute text-white'></i>"
      this._player.mute()
      this._displayMuteStatus()
    }
    this._isMuted = !this._isMuted
  }

  _toggleFullscreen(){
    let video = this._phxComponent.el.querySelector('video')
    if (video.requestFullscreen) {
      video.requestFullscreen();
    } else if (video.webkitRequestFullscreen) { /* Safari */
      video.webkitRequestFullscreen();
    } else if (video.webkitEnterFullscreen) { /* Safari 2 ( ios >=16 )*/
      video.webkitEnterFullscreen();
    } else if (video.msRequestFullscreen) { /* IE11 */
      video.msRequestFullscreen();
    }
  }

  _togglePictureInPicture(){
    if (document.pictureInPictureElement ) {
      document.exitPictureInPicture();
    } else {
      if (document.pictureInPictureEnabled) {
        let videoEl = this._container.querySelector('video')
        videoEl.requestPictureInPicture();
        videoEl.onleavepictureinpicture = () => {
          this._container.parentElement.style.display = null
        }
        this._container.parentElement.style.display = "none"
      }
    }
  }

  _playerStartPlaying(){
    this._isMuted = !this._isMuted
    this._toggleMute()
    this._playerStarted = true
    this._removeLoading()
  }

  _setStateToUnMuted(){
    this._isMuted = false
    this._toggleMute()
  }

  _displayMuteStatus(){
    let status = document.createElement('div')
    status.innerHTML = "Muted"
    status.className = "absolute top-4 right-4 p-2 bg-gray-100 text-gray-700 mute-status"
    this._muteStatus = status
    this._container.appendChild(this._muteStatus)
  }

  _removeMuteStatus(){
    let node = this._container.querySelector('.mute-status')
    if (node) {
      node.remove() // For Safari ...
      this._muteStatus.remove()
    }
  }

  _displayPlayButton(cb){
    let container = document.createElement('div')
    container.className = "absolute inset-0 flex items-center justify-center z-50"

    let button = document.createElement('div')
    button.innerHTML = "<i class='fas fa-4x fa-play'></i>"
    button.className = "m-auto cursor-pointer text-primary"
    button.addEventListener('click', () => {
      console.log("Play clicked")
      if (typeof(cb) == 'function') { cb() }
      this._playButtonContainer.remove()
    })

    container.appendChild(button)

    this._playButton = button
    this._playButtonContainer = container
    this._container.appendChild(container)
  }

  _displayLoading(){
    console.log("loading....")
    let container = document.createElement('div')
    container.className = "absolute inset-0 flex items-center justify-center z-10 bg-black bg-opacity-50"

    let spinner = document.createElement('div')
    spinner.innerHTML = "<div></div><div></div>"
    spinner.className = "a-loader ripple"

    container.appendChild(spinner)
    this._loadingContainer = container
    this._container.appendChild(container)
  }
  _removeLoading(){
    this._loadingContainer.remove()
  }

  destroy(){
    this._removeMuteStatus()
    this._player && this._player.destroy()
    //this._container.innerHTML = ""
  }
}

export default Player;
